export interface DraftApiClientOptions {
  candidates: string[];
  fetchImpl?: typeof fetch;
  unavailableMessage?: (lastError: string) => string;
}

export interface DraftApiClient {
  request(path: string, options?: RequestInit): Promise<Response>;
}

function normalizeCandidate(value: string): string {
  return String(value || "").replace(/\/$/, "");
}

export function createDraftApiClient({
  candidates,
  fetchImpl = globalThis.fetch,
  unavailableMessage = lastError => `Could not reach the backend API. Last error: ${lastError}`
}: DraftApiClientOptions): DraftApiClient {
  const apiCandidates = candidates.map(normalizeCandidate).filter(Boolean);
  if (typeof fetchImpl !== "function") {
    throw new Error("A fetch implementation is required to create the Draft API client.");
  }

  return {
    async request(path, options) {
      let lastError = "network error";

      for (const baseUrl of apiCandidates) {
        try {
          const response = await fetchImpl(baseUrl + path, options);
          if (response.status === 404 || response.status === 405) {
            continue;
          }
          return response;
        } catch (error) {
          lastError = error instanceof Error && error.message ? error.message : String(error);
        }
      }

      throw new Error(unavailableMessage(lastError));
    }
  };
}
